import styled from 'styled-components'

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const LABEL_WIDTH = '30%'
